// Shared viewport queries for the mobile Live view (#86bb5dx62), kept in one
// place so the JS gates and the CSS breakpoints in liveStyle.css can't drift.
const PORTRAIT_PHONE = '(max-width: 767px)';
const LANDSCAPE_PHONE =
  '(orientation: landscape) and (max-height: 500px) and (max-width: 932px)';

// isLandscapePhone — a wide+short phone in landscape (the same query the landscape
// rail uses).
export const isLandscapePhone = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(LANDSCAPE_PHONE).matches;
};

// isLandscapeCompact — any phone-OR-tablet landscape (landscape orientation up to the desktop
// breakpoint, <=1279). General viewport query, symmetric with isMobilePortrait. (No longer wired
// to conf-2: side-by-side is now conf-2's BASE geometry in util/layouts, stacking only in portrait,
// so no landscape override is needed. Kept as a shared helper.)
export const isLandscapeCompact = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(orientation: landscape) and (max-width: 1279px)').matches;
};

// isTouchDragViewport — whether drag-to-swap of on-view cameras should be enabled
// (L-D9). True for a touch phone in EITHER portrait (narrow) or landscape (wide+short);
// false on desktop, so the mouse zoom-select interaction stays untouched.
export const isTouchDragViewport = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(PORTRAIT_PHONE).matches || isLandscapePhone();
};

// isMobilePortrait — portrait orientation up to the desktop breakpoint: mobile AND tablet portrait share
// ONE portrait treatment (#86bb7phhh 2026-08-07, David: mobile + tablet portrait must match). Drives the
// conf-2 STACK + conf-6 / conf-12 grid TRANSPOSE (2×3 / 3×4 instead of 3×2 / 4×3) + their matching picker
// glyphs, so tall 16:9 tiles letterbox less. Excludes landscape (wide) and desktop (≥1024, which is
// landscape-family even in portrait). Named for its origin tier; now covers all portrait ≤1023.
export const isMobilePortrait = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(max-width: 1023px) and (orientation: portrait)').matches;
};
